module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M26 8c0-1.106-.894-2-2-2H2C.894 6 0 6.894 0 8v22c0 1.106.894 2 2 2h22c1.106 0 2-.894 2-2V8zm-9.082 2a3.001 3.001 0 0 1 0 6 3.001 3.001 0 0 1 0-6zM4 27v-8.75c0-.552.65-1.316 1.042-1.708l2.752-2.586c.39-.39 1.108-.39 1.498 0l5.336 7.292 3.312-3.29c.39-.39 1.036-.39 1.426 0l2.256 2.586c.336.334.378.94.378 1.456v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zM8 0C6.894 0 6 .894 6 2v2h20c1.106 0 2 .894 2 2v20h2c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2H8z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/image-gallery-1.js
// module id = 1181
// module chunks = 14